import React from "react";
import { connect } from "react-redux";
import ReactGA from "react-ga";

import { URL_DOWNLOAD_DATA } from "../../utils/api";
import { reverseMapVariablesSlug, allCenters } from "../../utils/general";

import "./DownloadLink.css";

const DownloadLink = props => {
  let prefix = "";
  if (props.baseline === "GBON") {
    prefix = "gbon_";
  }

  const ftype = props[prefix + props.fileType];
  let selectedCountries = props.searchedStations.selectedCountries;
  const clickHandler = event => {
    // Add Google analytics event to track click on 'download data' link
    if (window.location.hostname !== "localhost") {
      ReactGA.event({
        category: "User Interaction",
        action: "Click on download data link",
        label: event.target.getAttribute("href")
      });
    }
  };

  let periodString = "";
  if (ftype.selectedPeriodType === "six_hour") {
    periodString = `&period=${ftype.selectedSixHPeriod}`;
  }
  let variableString = `&variable=${reverseMapVariablesSlug(
    props.fileType,
    ftype.selectedVariable
  )}`;
  // TEMP/six-hour/availability is not by variable
  if (
    props.fileType === "temp" &&
    ftype.selectedPeriodType === "six_hour" &&
    ftype.selectedReport === "availability"
  ) {
    variableString = "";
  }

  let centersString = `&centers=${ftype.selectedCenter}`;
  if (ftype.selectedCenter === "all") {
    centersString = `&centers=COMBINED`;
  }

  let baselineString = "";
  // the baseline switch is only displayed for availability (SYNOP)
  // and availability/daily for TEMP
  if (
    (props.fileType === "synop" && ftype.selectedReport === "availability") ||
    (props.fileType === "temp" &&
      // ftype.selectedPeriodType === "daily" &&
      ftype.selectedReport === "availability")
  ) {
    baselineString = `&baseline=${ftype.baseline}`;
  }
  let Countries = "";
  if (selectedCountries !== "") {
    Countries = "&countries=" + selectedCountries;
  }

  let url;

  if (props.fileType === "synop" || props.fileType === "temp") {
    if (ftype.baseline === "GBON") {
      if (prefix === "") {
        // this means we are using the switcher from map menu
        let baselineType = "hourly";
        if (props.fileType === "temp") {
          baselineType = "2-daily";
        }
        baselineString = `&baseline=${baselineType}`;
        url = `${URL_DOWNLOAD_DATA}/nwp/${props.fileType}/${ftype.selectedPeriodType}/${ftype.selectedReport}/?date=${ftype.selectedDate}${periodString}${variableString}${centersString}${baselineString}${Countries}`;
      } else {
        // this means we are using the actual gbon module
        url = `${URL_DOWNLOAD_DATA}/gbon/${props.fileType}/${ftype.selectedPeriodType}/${ftype.selectedReport}/?date=${ftype.selectedDate}${periodString}${variableString}${centersString}${Countries}`;
      }
    } else {
      url = `${URL_DOWNLOAD_DATA}/nwp/${props.fileType}/${ftype.selectedPeriodType}/${ftype.selectedReport}/?date=${ftype.selectedDate}${periodString}${variableString}${centersString}${baselineString}${Countries}`;
    }
  } else if (props.fileType === "guan" || props.fileType === "gsn") {
    url = `${URL_DOWNLOAD_DATA}/${props.fileType}/${ftype.selectedReport}/?date=${ftype.selectedDate}${Countries}`;
  } else if (props.fileType === "marine_surface") {
    url = `${URL_DOWNLOAD_DATA}/${props.fileType}/${ftype.selectedPeriodType}/${ftype.selectedReport}/?date=${ftype.selectedDate}${periodString}${variableString}${centersString}${baselineString}${Countries}`;
  } else if (props.fileType === "wis2gtssynop") {
    // WISGTS SYNOP reports - no variable or centers parameter needed
    url = `${URL_DOWNLOAD_DATA}/wisgts/synop/${ftype.selectedPeriodType}/${ftype.selectedReport}/?date=${ftype.selectedDate}${Countries}`;
  } else if (props.fileType === "wis2gtstemp") {
    // WISGTS TEMP reports - no variable or centers parameter needed
    url = `${URL_DOWNLOAD_DATA}/wisgts/temp/${ftype.selectedPeriodType}/${ftype.selectedReport}/?date=${ftype.selectedDate}${Countries}`;
  }

  return (
    <div className="downloadlink-container">
      <a
        href="https://wmo.int/disclaimer"
        target="_blank"
        className="disclaimer_link"
        rel="noreferrer"
      >
        © WMO
      </a>
      <a href={url} onClick={clickHandler}>
        Download data
      </a>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    synop: state.synop,
    temp: state.temp,
    gbon_synop: state.gbon_synop,
    gbon_temp: state.gbon_temp,
    guan: state.guan,
    gsn: state.gsn,
    buoy: state.buoy,
    ship: state.ship,
    marine_surface: state.marine_surface,
    wis2gtssynop: state.wis2gtssynop,
    wis2gtstemp: state.wis2gtstemp,
    searchedStations: state.searchedStations
  };
};

export default connect(mapStateToProps)(DownloadLink);
